var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mycheck"},[_c('input',{attrs:{"type":"checkbox","disabled":true},domProps:{"checked":_vm.checked,"value":_vm.checkValue},on:{"change":function($event){return _vm.checkChange($event)}}}),_c('span',[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }